import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../shared/utils/objects';
import { UserFilter } from '../../../../shared/types/user';
import { profiles } from '../../../../shared/types/profiles';

export const useUserFilters = (onFilter?: (data: UserFilter) => void) => {
    const onSubmit = (data: UserFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    return {
        formik,
        profiles,
    };
};
